import styled from 'styled-components';
import {LargeSectionHeader} from '../../../../CommonStyleUtils/dwebCommon.styles';

export const PropertyRuleCont = styled.div`
  width: 100%;
  margin-top: 2rem;
`;
export const PropertyRuleInner = styled.div`
  width: 120rem;
  margin: 0 auto;
`;
export const Card = styled.div`
  background-color: #fff;
  border-radius: 1.2rem;
`;
export const PropertyRuleHeader = styled(LargeSectionHeader)(
  props => `
  border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge};
  border-bottom-left-radius:0;
  border-bottom-right-radius:0;
`,
);
export const PropertyRuleSubHeader = styled.span`
  font-weight: bold;
  font-size: 1.4rem;
  color: #647a97;
  margin-top: 0.4rem;
`;
export const PropertyRules = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  padding: 2rem 2.4rem;
`;
